export const FILE_ERROR = {
  MAX_SIZE: "max_size",
  INVALID_MIME: "invalid_mime"
};

export const IMAGE_MIME_TYPES = ["image/jpeg", "image/gif", "image/png"];

export const COMPONENT_KEYWORD = {
  DOCUMENTS_WELCOME_KIT_CLIENT: "documents-welcome-kit-client"
};
